import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MindToMasterLanding from "./components/MindToMasterLanding";
import MeditationLanding from "./components/MeditationLanding";
import MeditationCheckout from "./components/MeditationCheckout";

function App() {
  const pathname = window.location.pathname;
  const hostname = window.location.hostname.toLowerCase();
  const meditationHost =
    hostname === "meditation.mindtomaster.com" ||
    hostname === "meditationbundle.mindtomaster.com";
  const meditationFolderDeploy = pathname === "/meditationbundle" || pathname.startsWith("/meditationbundle/");
  const testSeriesFolderDeploy = pathname === "/testseries" || pathname.startsWith("/testseries/");
  const showMeditation = meditationHost || meditationFolderDeploy;
  const basename = meditationFolderDeploy
    ? "/meditationbundle"
    : testSeriesFolderDeploy
      ? "/testseries"
      : undefined;

  return (
    <div className="App">
      <BrowserRouter basename={basename}>
        <Routes>
          <Route path="/" element={showMeditation ? <MeditationLanding /> : <MindToMasterLanding />} />
          {showMeditation && <Route path="/checkout" element={<MeditationCheckout />} />}
          <Route path="/meditation-bundle" element={<MeditationLanding />} />
          <Route path="/meditation-bundle/checkout" element={<MeditationCheckout />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
